export default __webpack_public_path__ + "static/media/solteiroduplo_9.abc6a5c0.jpg";